
function getCount() {
    let initialDate = new Date('2019-08-20T00:00:00').getTime() 
    let actualDate = new Date().getTime() 

    let time = initialDate - actualDate
    let seconds = time / 1000
    let minutes = parseInt(seconds / 60)
    let total = Math.abs(parseInt(minutes / 3))

    return total
}

function observerCounter(counter, count) {
    let itemsCount = Array.from(counter.children)

    itemsCount.forEach((item, index) => {
        let numberElement = parseInt(item.getAttribute('data-number'))
        let numberCounter = parseInt(count[index])

        if(numberCounter != numberElement) {
            console.log('No lo son');
            item.classList.add('animation-counter')
        }
    })
}
function activeObserver() {
    let counter = document.getElementById('counter')
    let observer = new MutationObserver(mutationRecords => {
        console.log(mutationRecords); 
      });

    observer.observe(counter, {
        attributes: true // pass old data to callback
      });
}

function renderTime() {
    let counter = document.getElementById('counter')
    
    let count = getCount()

    let arrCount = String(count).split('')

    counter.innerHTML = ''
    for (const [index, number] of arrCount.entries()) {
        
        counter.innerHTML += `
        <div class="home-counter__number" data-number="${number}">
            <div class="home-counter__number-first-half"></div>
            <div class="home-counter__number-line"></div>
            <span style="z-index: 10;">${number}</span>
            <div class="home-counter__number-second-half" id="counter${index}"></div>
        </div>
        `
    }


}

function change() {
    setInterval(() => {        
        renderTime()
    }, 3000);
}

window.addEventListener('load', async () => {

    await renderTime()
    await change()
    await activeObserver()
})